// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rHnpsWQZAffS65HZSDBH {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  padding: 2rem;
  text-align: center;
  font-family: Inter, sans-serif;
}

.LJyLP0o12VC77CErQ4C5 {
  min-height: 100vh;
}

._02dsB9QAncEYld7Adk9 {
  font-size: 3rem;
  font-weight: 700;
  color: #000000;
  margin-top: 24px;
  margin-bottom: 0;
  letter-spacing: -2.5px;
  font-weight: 600;
  letter-spacing: -2px;
}

.cKn01FVIg0b3fC4krmOE {
  font-size: 1.125rem;
  color: #1f1f1f;
  margin: 0;
  font-weight: 400;
}

.Jcv5_7xG79u72Ldl4xG3 {
  display: block;
  font-size: 1rem;
  color: #707070;
  margin-top: 8px;
  font-weight: 500;
  font-weight: 400;
}

.GWL0o4qhccR1MDTeC2yv {
  margin-top: 24px;
  margin-bottom: 32px;
}
`, "",{"version":3,"sources":["webpack://./src/components/ErrorBoundary/DefaultErrorFallback/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":[".defaultErrorFallback {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: #ffffff;\n  padding: 2rem;\n  text-align: center;\n  font-family: Inter, sans-serif;\n}\n\n.fullScreen {\n  min-height: 100vh;\n}\n\n.title {\n  font-size: 3rem;\n  font-weight: 700;\n  color: #000000;\n  margin-top: 24px;\n  margin-bottom: 0;\n  letter-spacing: -2.5px;\n  font-weight: 600;\n  letter-spacing: -2px;\n}\n\n.description {\n  font-size: 1.125rem;\n  color: #1f1f1f;\n  margin: 0;\n  font-weight: 400;\n}\n\n.errorCode {\n  display: block;\n  font-size: 1rem;\n  color: #707070;\n  margin-top: 8px;\n  font-weight: 500;\n  font-weight: 400;\n}\n\n.textWrapper {\n  margin-top: 24px;\n  margin-bottom: 32px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"defaultErrorFallback": `rHnpsWQZAffS65HZSDBH`,
	"fullScreen": `LJyLP0o12VC77CErQ4C5`,
	"title": `_02dsB9QAncEYld7Adk9`,
	"description": `cKn01FVIg0b3fC4krmOE`,
	"errorCode": `Jcv5_7xG79u72Ldl4xG3`,
	"textWrapper": `GWL0o4qhccR1MDTeC2yv`
};
export default ___CSS_LOADER_EXPORT___;
